import { DOCUMENT } from '@angular/common';
import { Injectable, Inject, RendererFactory2, NgModule, InjectionToken } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/platform-browser';
import * as ɵngcc2 from '@angular/common/http';
class SeoService {
    constructor(
    // TODO: fix 'tslint:disable-next-line: typedef'. Document type cause error when compile
    // tslint:disable-next-line: typedef
    _dom, _meta, _rendererFactory, _title) {
        this._dom = _dom;
        this._meta = _meta;
        this._rendererFactory = _rendererFactory;
        this._title = _title;
        this._renderer = this._rendererFactory.createRenderer(null, null);
    }
    generateCanonicalURL() {
        const LINK = this._renderer.createElement('link');
        this._renderer.setAttribute(LINK, 'rel', 'canonical');
        this._renderer.appendChild(this._dom.head, LINK);
        LINK.setAttribute('href', this._dom.URL);
    }
    generateTags(config = {}) {
        // default values
        config = Object.assign({ title: 'Mi Águila - Movilizándote a donde sueñas llegar', description: `Mi Águila es una empresa de tecnología
      enfocada en brindar soluciones de transporte, cambiando
      la forma en cómo nos movemos en las ciudades de Latinoamérica.`, image: 'https://angularfirebase.com/images/logo.png', robots: 'follow,index', slug: '' }, config);
        /* Essential META Tags */
        this._meta.updateTag({ name: 'description', content: config.description });
        this._meta.updateTag({ name: 'fragment', content: '!' });
        this._meta.updateTag({ name: 'robots', content: config.robots });
        this._meta.updateTag({ property: 'og:type', content: 'website' });
        this._meta.updateTag({ property: 'og:site_name', content: 'Mi Águila' });
        this._meta.updateTag({ property: 'og:title', content: config.title });
        this._meta.updateTag({ property: 'og:description', content: config.description });
        this._meta.updateTag({ property: 'og:image', content: config.image });
        this._meta.updateTag({ property: 'og:url', content: `https://miaguila.com/${config.slug}` });
        this._meta.updateTag({ property: 'og:locale', content: 'es_la' });
        this._meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
        this._meta.updateTag({ name: 'twitter:title', content: config.title });
        this._meta.updateTag({ name: 'twitter:description', content: config.description });
        this._meta.updateTag({ name: 'twitter:image', content: config.image });
        this._meta.updateTag({ name: 'twitter:image:src', content: config.image });
        this._meta.updateTag({ name: 'twitter:url', content: `https://miaguila.com/${config.slug}` });
        this._meta.updateTag({ name: 'twitter:widgets:csp', content: 'on' });
        /* Non-Essential, But Recommended */
        this._meta.updateTag({ name: 'og:site_name', content: 'Mi Águila' });
        this._meta.updateTag({ name: 'twitter:image:alt', content: config.description });
        this._meta.updateTag({ name: 'mobile-web-app-capable', content: 'yes' });
        this._meta.updateTag({ name: 'apple-mobile-web-app-capable', content: 'yes' });
        this._meta.updateTag({ name: 'application-name', content: 'Mi Águila' });
        this._meta.updateTag({ name: 'apple-mobile-web-app-title', content: 'Mi Águila' });
        this._meta.updateTag({ name: 'author', content: 'Mi Águila' });
        /* Non-Essential, But Required for Analytics */
        // TODO: Ask for Mi Águila Facebook Id (e.g. 1850089328610772)
        this._meta.updateTag({ name: 'fb:app_id', content: 'mi_aguila_id' });
        this._meta.updateTag({ name: 'twitter:site', content: '@miaguila_' });
        this._meta.updateTag({ name: 'twitter:creator', content: '@miaguila_' });
    }
    generateTitle(text) {
        this._title.setTitle(text);
    }
}
SeoService.ɵfac = function SeoService_Factory(t) { return new (t || SeoService)(ɵngcc0.ɵɵinject(DOCUMENT), ɵngcc0.ɵɵinject(ɵngcc1.Meta), ɵngcc0.ɵɵinject(ɵngcc0.RendererFactory2), ɵngcc0.ɵɵinject(ɵngcc1.Title)); };
SeoService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SeoService, factory: SeoService.ɵfac });
SeoService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Meta },
    { type: RendererFactory2 },
    { type: Title }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SeoService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc1.Meta }, { type: ɵngcc0.RendererFactory2 }, { type: ɵngcc1.Title }]; }, null); })();
/*
References:
https://medium.com/slalom-engineering/bringing-seo-to-angular-applications-9de14995dc67
https://angularfirebase.com/lessons/seo-angular-part-1-rendertron-meta-tags/
*/

class SeoServiceModule {
}
SeoServiceModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SeoServiceModule });
SeoServiceModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SeoServiceModule_Factory(t) { return new (t || SeoServiceModule)(); }, providers: [
        SeoService
    ] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SeoServiceModule, [{
        type: NgModule,
        args: [{
                providers: [
                    SeoService
                ]
            }]
    }], null, null); })();

// tslint:disable: ban-types
const ZAPIER_CONFIG = new InjectionToken('ZAPIER_CONFIG');
class ZapierService {
    constructor(_http, _zapierConfig) {
        this._http = _http;
        this._zapierConfig = _zapierConfig;
    }
    delete(options) {
        return this._http.delete(`${this._zapierConfig.zapierUrl}`, options);
    }
    get(options) {
        return this._http.get(`${this._zapierConfig.zapierUrl}`, options);
    }
    post(options) {
        return this._http.post(`${this._zapierConfig.zapierUrl}`, options);
    }
    put(options) {
        return this._http.put(`${this._zapierConfig.zapierUrl}`, options);
    }
}
ZapierService.ɵfac = function ZapierService_Factory(t) { return new (t || ZapierService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(ZAPIER_CONFIG)); };
ZapierService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ZapierService, factory: ZapierService.ɵfac });
ZapierService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [ZAPIER_CONFIG,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ZapierService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [ZAPIER_CONFIG]
            }] }]; }, null); })();

class ZapierServiceModule {
    static forChild(config) {
        return {
            ngModule: ZapierServiceModule,
            providers: [
                ZapierService,
                { provide: ZAPIER_CONFIG, useValue: config || null }
            ]
        };
    }
    static forRoot(config) {
        return {
            ngModule: ZapierServiceModule,
            providers: [
                ZapierService,
                { provide: ZAPIER_CONFIG, useValue: config || null }
            ]
        };
    }
}
ZapierServiceModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ZapierServiceModule });
ZapierServiceModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ZapierServiceModule_Factory(t) { return new (t || ZapierServiceModule)(); }, imports: [[
            HttpClientModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ZapierServiceModule, { imports: function () { return [HttpClientModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ZapierServiceModule, [{
        type: NgModule,
        args: [{
                imports: [
                    HttpClientModule
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SeoService, SeoServiceModule, ZAPIER_CONFIG, ZapierService, ZapierServiceModule };

//# sourceMappingURL=miaguila-common.js.map